import * as React from "react";
import { forwardRef } from "react";
const SvgNotification = (props, ref) => /* @__PURE__ */ React.createElement("svg", { id: "notification-bell", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: "icon line", width: 48, height: 48, ref, ...props }, /* @__PURE__ */ React.createElement("path", { id: "primary", d: "M19.38,14.38a2.12,2.12,0,0,1,.62,1.5h0A2.12,2.12,0,0,1,17.88,18H6.12A2.12,2.12,0,0,1,4,15.88H4a2.12,2.12,0,0,1,.62-1.5L6,13V9a6,6,0,0,1,6-6h0a6,6,0,0,1,6,6v4ZM15,18H9a3,3,0,0,0,3,3h0A3,3,0,0,0,15,18Z", style: {
  fill: "none",
  stroke: "rgb(255, 255, 255)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
} }));
const ForwardRef = forwardRef(SvgNotification);
export { ForwardRef as ReactComponent };
